module.exports = __webpack_public_path__ + "static/media/white-power-quality.cd610128.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/white-power-quality.svg
// module id = 309
// module chunks = 0